"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var types = __importStar(require("@babel/types"));
var utils_1 = require("../utils");
function parseAttr(_a) {
    var keyString = _a.keyString, dg = _a.dg, childrens = _a.childrens, attrs = _a.attrs, attr = _a.attr;
    attrs.push.apply(attrs, attr.value.properties.map(function (v) {
        if (!types.isObjectProperty(v))
            return;
        var key = utils_1.getCamelCase(keyString, v.key.value || v.key.name);
        if (["attrs", "props"].includes(keyString)) {
            key = v.key.name || v.key.value;
        }
        return types.jsxAttribute(types.jsxIdentifier(key), types.jsxExpressionContainer(v.value));
    }));
}
exports.parseAttr = parseAttr;
//# sourceMappingURL=attr.js.map